module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba-funabashi-point2-2@3x-d1dcd26a7c6b450e884cb4ef004d9ff3.webp";